import styles from './item-simple.module.scss';

import epicSwordImg from 'assets/images/game/market/sword-epic.png';

function ItemSimple({ className, isChecked, onCheckboxChange }) {
  const classNames = [styles['container']];
  if (className) {
    classNames.push(className)
  }
  return (
    <label className={classNames.join(' ')}>
      <input type="radio" name="item-simple" className="hidden" checked={isChecked} onChange={onCheckboxChange} />
      <div className={styles['background']}></div>
      <img src={epicSwordImg} alt="Epic sword"/>
      <span>x99</span>
      <div className={styles['highlight']}></div>
    </label>
  );
}

export default ItemSimple;
